import { axios } from 'system/axios'

export const getConfigDictionary = () => axios.get<Record<string, string[]>>('/config/dictionary')
